import {Theme} from '@mui/material/styles';
import {SxProps} from '@mui/system';
import {useGroupScheduleA} from '@ozark/common';
import {GroupScheduleACommon, Loading} from '@ozark/common/components';

type Props = {
  groupId: string;
  hideLabels?: boolean;
  riskTogglesEnabled?: boolean;
  hideVersion?: boolean;
  riskLevelSx?: SxProps<Theme>;
};

export const GroupScheduleA = ({
  groupId,
  hideLabels,
  hideVersion,
  riskTogglesEnabled = true,
  riskLevelSx = undefined,
}: Props) => {
  const {document: groupScheduleA} = useGroupScheduleA(groupId);

  if (groupScheduleA.promised) {
    return <Loading />;
  }

  return (
    <GroupScheduleACommon
      document={groupScheduleA.data}
      readonly
      hideLabels={hideLabels}
      riskTogglesEnabled={riskTogglesEnabled}
      hideVersion={hideVersion}
      riskLevelSx={riskLevelSx}
    />
  );
};
